import { useTranslation } from '@web_opxp/features';
import PredictorWidget from './PredictorWidget';

export default function GameplayToReachNextLevelIfSelectedNotMaxReached() {
  const { t } = useTranslation();
  const title = t('SuccessPredictor.SelectedNotMax.Title');
  const description = t('SuccessPredictor.SelectedNotMax.Description');
  return <PredictorWidget title={title} description={description} />;
}
